{
  "dashboardTitle": "Job Scheduler",
  "dashboardSubtitle": "Monitor and manage scheduled jobs",
  "allDefinitions": "All Definitions",
  "allExecutions": "All Executions",
  "newJobDefinition": "New Job",
  "totalDefinitions": "Total Definitions",
  "activeDefinitions": "Active Definitions",
  "completedToday": "Completed Today",
  "failedToday": "Failed Today",
  "jobDefinitions": "Job Definitions",
  "recentExecutions": "Recent Executions",
  "viewAll": "View All",
  "noJobDefinitions": "No job definitions found",
  "createFirst": "Create your first job",
  "noRecentExecutions": "No recent executions",
  "name": "Name",
  "jobType": "Type",
  "handlerType": "Handler",
  "cronExpression": "Cron",
  "status": "Status",
  "actions": "Actions",
  "jobDefinition": "Job Definition",
  "startedAt": "Started At",
  "duration": "Duration",
  "attempt": "Attempt",
  "active": "Active",
  "inactive": "Inactive",
  "edit": "Edit",
  "activate": "Activate",
  "deactivate": "Deactivate",
  "triggerNow": "Trigger Now",
  "viewDetail": "View Detail",
  "toggleSuccess": "Toggle Success",
  "jobActivated": "Job has been activated successfully",
  "jobDeactivated": "Job has been deactivated successfully",
  "triggerSuccess": "Trigger Success",
  "jobTriggered": "Job has been triggered successfully",
  "loading": "Loading...",
  "breadCrumbs": {
    "jobScheduler": "Job Scheduler"
  }
}
